module.exports = __webpack_public_path__ + "img/index1.63c703c6.png";